"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationManager = void 0;
var tslib_1 = require("tslib");
var firebaseAuthenticationManager_1 = require("./firebaseAuthenticationManager");
/**
 * @class
 * @remarks This class provides the implementation for Authentication management operations.
 */
var AuthenticationManager = /** @class */ (function () {
    function AuthenticationManager() {
        this.authService = new firebaseAuthenticationManager_1.FirebaseAuthenticationManager();
    }
    AuthenticationManager.prototype.initialize = function () {
        try {
            this.authService.initializeFirebase();
        }
        catch (error) {
            console.error('Error in AuthenticationManager initialize:', error);
            throw error;
        }
    };
    AuthenticationManager.prototype.register = function (email, password) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.authService.register(email, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error in AuthenticationManager register:', error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationManager.prototype.login = function (email, password) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.authService.login(email, password)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Error in AuthenticationManager login:', error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationManager.prototype.logout = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.authService.logout()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.error('Error in AuthenticationManager logout:', error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationManager.prototype.resetPassword = function (email) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.authService.resetPassword(email)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.error('Error in AuthenticationManager resetPassword:', error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationManager.prototype.updateUserDetails = function (userDetails) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.authService.updateUserDetails(userDetails)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_5 = _a.sent();
                        console.error('Error in AuthenticationManager updateUserDetails:', error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationManager.prototype.deactivateUser = function (userID) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.authService.deactivateUser(userID)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        console.error('Error in AuthenticationManager deactivateUser:', error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationManager.prototype.fetchSignInMethodsForEmail = function (userEmail) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.authService.fetchSignInMethodsForEmail(userEmail)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_7 = _a.sent();
                        console.error('Error in AuthenticationManager fetchSignInMethodsForEmail:', error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationManager.prototype.signInWithCustomToken = function (token) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_8;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.authService.signInWithCustomToken(token)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_8 = _a.sent();
                        console.error('Error in AuthenticationManager signInWithCustomToken:', error_8);
                        throw error_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationManager.prototype.deleteUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_9;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.authService.deleteUser()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_9 = _a.sent();
                        console.error('Error in AuthenticationManager deleteUser:', error_9);
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationManager.prototype.getUser = function () {
        try {
            return this.authService.getUser();
        }
        catch (error) {
            console.error('Error in AuthenticationManager getUser');
            throw error;
        }
    };
    AuthenticationManager.prototype.getAccessToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_10;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.authService.getAccessToken()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_10 = _a.sent();
                        console.error('Error in AuthenticationManager getAccessToken');
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return AuthenticationManager;
}());
exports.AuthenticationManager = AuthenticationManager;
